import script from "./AutomationEmails.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationEmails.vue?vue&type=script&setup=true&lang=js"

import "./AutomationEmails.vue?vue&type=style&index=0&id=51f91f5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f91f5a"]])

export default __exports__